export interface State {
  runningTrade: RunningTradeList;
}

export const state: State = {
  runningTrade: {
    company: {
      data: [],
      batch: [],
      filter: '',
      isActive: false,
      isQueue: false,
      isPaused: false,
    },

    widget: {
      data: [],
      batch: [],
      filter: '',
      isActive: false,
      isQueue: false,
      isPaused: false,
    },

    fastOrder: {
      data: [],
      batch: [],
      filter: '',
      isActive: false,
      isQueue: false,
      isPaused: false,
    },
  },
};
